import type { VaultExposure, } from "@types";


export const initialExposure: VaultExposure = {

	participant: false,
	invested_brkt: 0n,
	invested_usd: 0,
	shares: 0,
	shares_pending_withdrawal: 0,
	vault_balance: 0n,
	active_shares: 0,
	current_value: {
		usd: 0,
		brkt: ""
	},
	cost_basis: {
		usd: 0,
		brkt: ""
	},
	est_annual_earnings: {
		usd: 0,
		brkt: ""
	},
	open_value: {
		usd: 0,
		brkt: ""
	},
	orig_cost_basis: {
		usd: 0,
		brkt: ""
	},
	unrealized_gain: {
		usd: 0,
		brkt: "",
		perc: 0,
	},
	realized_gain: {
		usd: 0,
		brkt: ""
	},
	pnl: {
		usd: 0,
		brkt: "",
		perc: 0,
	},
	apy: {
		perc: 0,
		brkt: "",
		usd: 0,
	},

};
